
















import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import FarmEmpty from "../farm-empty/FarmEmpty.vue";
import FarmItem from "../farm-item/FarmItem.vue";
import { Farm } from "@/api/farms/types";

@Component({
  name: "FarmsList",
  components: {
    FarmEmpty,
    FarmItem
  }
})
export default class FarmsList extends Vue {
  @Prop({ type: Array, required: true })
  private farmsList!: Farm[];

  private get isEmpty() {
    return this.farmsList.length === 0;
  }

  @Emit('click:empty')
  private emitClickEmpty() {}

  private sendFarmForAnalysis(farm: Farm) {
    this.$emit("analysis:open", farm);
  }

  private sendAnalysisType(analysisType: string) {
    this.$emit("analysis:type", analysisType);
  }

  private deleteFarm(farm: Farm){
     this.$emit("delete:farm", farm);
  }

}
